<template>
	<div class="w-table-layout w-table-page">
		<div class="w-table-content"
			 ref="tableContent">
			<el-table :data="tableData"
					  highlight-current-row
					  v-loading="loading"
					  stripe
					  border
					  :height="tableH">
				<el-table-column type="index"
								 label="序号"
								 align="center"
								 width="70">
				</el-table-column>
				<el-table-column prop="sysCode"
								 label="编号"
								 show-overflow-tooltip
								 align="center"
								 min-width="120">
				</el-table-column>
				<el-table-column prop="sname"
								 label="资源名称"
								 align="center"
								 min-width="200">
				</el-table-column>
				<el-table-column prop="specification"
								 label="规格/型号"
								 align="center"
								 show-overflow-tooltip
								 min-width="130">
					<template slot-scope="scope">
						<div>
							{{ scope.row.specification ? scope.row.specification :'/' }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="unitName"
								 label="单位"
								 align="center"
								 min-width="120">
					<template slot-scope="scope">
						<div>
							{{ scope.row.unitName ? scope.row.unitName :'/' }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="withTax"
								 label="含税价(元)"
								 align="right"
								 min-width="120">
					<template slot-scope="scope">
						<div>
							{{ scope.row.withTax ? scope.row.withTax :'/' }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="excise"
								 show-overflow-tooltip
								 label="除税价(元)"
								 align="right"
								 min-width="120">
					<template slot-scope="scope">
						<div>
							{{ scope.row.excise ? scope.row.excise :'/' }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="taxRate"
								 label="税率"
								 align="center"
								 min-width="120">
					<template slot-scope="scope">
						<div>{{ scope.row.taxRate ? scope.row.taxRate :'/' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="yearAndMonth"
								 label="月份"
								 align="center"
								 min-width="120">
				</el-table-column>
				<el-table-column prop="priceType"
								 label="价格类型"
								 align="center"
								 width="130">
					<template slot-scope="scope">
						<div>{{ scope.row.priceType === 1 ? '信息价' : '市场价' }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="sourceTypeName"
								 label="资源类型"
								 align="center"
								 show-overflow-tooltip
								 width="120">
				</el-table-column>
				<el-table-column prop="areaName"
								 label="地区"
								 align="center"
								 width="120">

				</el-table-column>
				<el-table-column prop="priceResource"
								 label="信息来源"
								 align="center"
								 width="120">
				</el-table-column>
				<el-table-column label="操作"
								 align="center"
								 min-width="100">
					<template slot-scope="scope">
						<el-button @click="editClick(scope.row)"
								   icon="el-icon-edit"
								   title="编辑"
								   type="text"
								   size="small"></el-button>
						<el-button @click="deleteClick(scope.row)"
								   type="text"
								   icon="el-icon-delete"
								   title="删除"
								   size="small"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="w-table-footer">
			<el-pagination @size-change="SizeChange"
						   @current-change="CurrentChange"
						   :current-page="currentPage"
						   :page-sizes="pageList"
						   :page-size="pageSize"
						   layout="total, sizes, prev, pager, next, jumper"
						   :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {
	selectResourcePage,
	deleteResource
} from '@/api/modules/resource_subscription'
import { provinceAndCityData } from 'element-china-area-data'
import { mapState } from 'vuex'
export default {
	name: 'cost-files-table',
	props: {
		searchForm: {
			type: Object,
			defatult: () => {
				return {}
			}
		}
	},
	data() {
		return {
			options: provinceAndCityData,
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			loading: false,
			tableData: [],
			tableH: 0
		}
	},
	created() {
		// 初始获得表格数据
		this.$nextTick(() => {
			this.getTableData()
			this.tableH = this.$refs.tableContent.offsetHeight
		})
	},
	methods: {
		// 初始获得数据
		getTableData() {
			let that = this
			// 设置参数
			let params = Object.assign({}, this.searchForm)
			params.current = this.currentPage
			params.size = this.pageSize
			this.loading = true
			selectResourcePage(params)
				.then(res => {
					this.loading = false
					if (res.code === 0) {
						let data = res.data.records
						data.forEach(v => {
							let areaName = ''
							let province = that.options.find(vt => {
								return v.province == vt.value
							})
							if (province != null) {
								areaName = province.label
								let city = province.children.find(vt => {
									return v.city == vt.value
								})
								if (city != null) areaName += ' / ' + city.label
							}
							v.areaName = areaName
						})
						this.tableData = data
						// this.currentPage = parseInt(res.data.current)
						this.total = parseInt(res.data.total)
						// this.pageSize = parseInt(res.data.size)
					} else {
						this.$message.error(res.msg)
					}
				})
				.catch(err => {
					this.loading = false
				})
		},

		//删除事件
		deleteClick(row) {
			this.$confirm('确认要删除当前数据吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					deleteResource({ id: row.id }).then(res => {
						if (res.code === 0) {
							this.$message.success('删除成功！')
							this.getTableData()
						} else {
							this.$message.error('删除失败！')
						}
					})
				})
				.catch(() => {})
		},

		//编辑事件
		editClick(row) {
			this.$emit('on-editChange', row)
		},
		// 切换显示条数
		SizeChange(val) {
			this.pageSize = val
			this.getTableData()
		},
		// 切换当前页码
		CurrentChange(current) {
			this.currentPage = current
			this.getTableData()
		}
	},
	computed: {
		...mapState('app', {
			clientSize: state => state.clientSize
		})
	},
	watch: {
		clientSize() {
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		}
	}
}
</script>
<style lang="less" scoped>
</style>